module.exports = __webpack_public_path__ + "static/media/HR@10x.b3a386ef.png";